<aside
  class="sidebar position-fixed top-0 start-0 vh-100 border-end"
  [class.sidebar-expanded]="(layoutService.isExpanded$ | async) || (layoutService.isHovered$ | async)"
  [class.sidebar-collapsed]="!(layoutService.isExpanded$ | async) && !(layoutService.isHovered$ | async)"
  [class.sidebar-mobile-open]="layoutService.isMobileOpen$ | async"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>

  <!-- 🔒 FIXED LOGO (NO SCROLL) -->
  <div class="sidebar-logo d-flex justify-content-between align-items-center px-3">
    <a routerLink="/" class="fw-bold">
      <img
        src="assets/logo/eventz-sidebar-logo.png"
        alt="Eventz Logo"
        loading="lazy"
        class="img-fluid"
        [style.height.px]="
        (layoutService.isExpanded$ | async) || (layoutService.isHovered$ | async)
          ? 40
          : 32
      "
      />
    </a>
    <!-- Mobile Close -->
    <button
      class="btn btn-sm d-xl-none"
      (click)="closeSidebar()"
      aria-label="Close sidebar"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>

  <!-- Menu -->
  <div class="sidebar-menu no-scrollbar py-3 px-2">
    <nav class="mb-6">
      <div class="flex flex-col">
        <!-- Menu Section -->
        <div>
          <ul class="flex flex-col gap-1">
            @for (nav of navItems; track $index; let i = $index) {
              <li>
                @if (nav.subItems) {
                  <button
                    (click)="toggleSubmenu('main',i)"
                    class="menu-item group cursor-pointer text-decoration-none"
                    [class.menu-item-active]="openSubmenu === 'main-' + i"
                    [class.menu-item-inactive]="openSubmenu !== 'main-' + i"
                    [ngClass]="{
                    'xl:justify-center': !(
                      (isExpanded$ | async) || (isHovered$ | async)
                    ),
                    'xl:justify-start':
                      (isExpanded$ | async) || (isHovered$ | async)
                  }"
                  >
                  <span
                    class="menu-item-icon-size"
                    [class.menu-item-icon-active]="openSubmenu === 'main-' + i"
                    [class.menu-item-icon-inactive]="openSubmenu !== 'main-' + i"
                    [innerHTML]="nav.icon | safeHtml"
                  >
                  </span>
                    @if ((isExpanded$ | async) || (isHovered$ | async) ||
                    (isMobileOpen$ | async)) {

                      <span class="menu-item-text">
                    {{ nav.name }}
                  </span>
                    }
                    @if (nav.new && ((isExpanded$ | async) || (isHovered$ |
                      async) || (isMobileOpen$ | async))) {
                      <span
                        class="ml-auto absolute right-10 menu-dropdown-badge"
                        [ngClass]="{
                      'menu-dropdown-badge-active': openSubmenu === 'main-' + i,
                      'menu-dropdown-badge-inactive': openSubmenu !== 'main-' + i
                    }"
                      >
                    new
                  </span>
                    }
                    @if ((isExpanded$ | async) || (isHovered$ | async) ||
                    (isMobileOpen$ | async)) {
                      <svg
                        [ngClass]="{
                      'rotate-180 text-brand-500': openSubmenu === 'main-' + i
                    }"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="ml-auto w-5 h-5 transition-transform duration-200"
                      >
                        <path
                          d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    }
                  </button>
                  <div
                    class="overflow-hidden transition-all duration-300"
                    [id]="'main-' + i"
                    [style.display]="
                    (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)
                      ? 'block'
                      : 'none'
                  "
                    [ngStyle]="{
                    height:
                      openSubmenu === 'main-' + i
                        ? (subMenuHeights['main-' + i] || 0) + 'px'
                        : '0px'
                  }"
                  >
                    <ul class="mt-2 space-y-1 ml-9">
                      @for (subItem of nav.subItems; track $index) {
                        <li>
                          <a
                            [routerLink]="subItem.path"
                            routerLinkActive=""
                            (click)="onSubmenuClick()"
                            class="menu-dropdown-item text-decoration-none"
                            [ngClass]="{
                              'menu-dropdown-item-inactive': !isActive(subItem.path),
                              'menu-dropdown-item-active': isActive(subItem.path),
                            }"
                          >
                            {{ subItem.name }}
                            <span class="flex items-center gap-1 ml-auto">
                          @if (subItem.new) {
                            <span
                              class="menu-dropdown-badge"
                              [ngClass]="{
                              'menu-dropdown-badge-active': isActive(
                                subItem.path
                              ),
                              'menu-dropdown-badge-inactive': !isActive(
                                subItem.path
                              )
                            }"
                            >
                            new
                          </span>
                          }
                              @if (subItem.pro) {
                                <span
                                  class="ml-auto menu-dropdown-badge-pro"
                                  [ngClass]="{
                              'menu-dropdown-badge-pro-active': isActive(
                                subItem.path
                              ),
                              'menu-dropdown-badge-pro-inactive': !isActive(
                                subItem.path
                              )
                            }"
                                >
                            pro
                          </span>
                              }
                        </span>
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                } @else {
                  @if (nav.path) {
                    <a
                      [routerLink]="nav.path"
                      routerLinkActive="menu-item-active"
                      class="menu-item group"
                      [ngClass]="{ 'menu-item-inactive': !isActive(nav.path) }"
                    >
                  <span
                    class="menu-item-icon-size"
                    [ngClass]="{
                      'menu-item-icon-active': isActive(nav.path),
                      'menu-item-icon-inactive': !isActive(nav.path)
                    }"
                    [innerHTML]="nav.icon | safeHtml"
                  >
                  </span>
                      <span
                        class="menu-item-text"
                      >
                    @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                      {{ nav.name }}
                    }
                  </span>
                    </a>
                  }
                }
              </li>
            }
          </ul>
        </div>
      </div>
    </nav>
  </div>
</aside>
